import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const AUTH_MEMBER_LANG: {
  AUTH_MEMBER_INVITE_TITLE: MvnCodeFE;
  AUTH_MEMBER_INVITE_HEADER: MvnCodeFE;
  AUTH_MEMBER_INVITE_SELECT_ORG_NAME_LABEL: MvnCodeFE;
  AUTH_MEMBER_INVITE_SELECT_ORG_NAME_PLACEHOLDER: MvnCodeFE;
  AUTH_MEMBER_INVITE_EMAIL_LABEL: MvnCodeFE;
  AUTH_MEMBER_INVITE_EMAIL_PLACEHOLDER: MvnCodeFE;
  AUTH_MEMBER_INVITE_EMPTY_ORG_NOTIFY: MvnCodeFE;
  AUTH_MEMBER_INVITE_EMPTY_EMAIL_NOTIFY: MvnCodeFE;
  AUTH_MEMBER_INVITE_INVALID_EMAIL_NOTIFY: MvnCodeFE;

  AUTH_MEMBER_INVITE_SUCC: MvnCodeFE;
  AUTH_MEMBER_INVITE_FAIL: MvnCodeFE;
  AUTH_MEMBER_INVITATION_ACCEPT_CONFIRM: MvnCodeFE;
  AUTH_MEMBER_INVITATION_REJECT_CONFIRM: MvnCodeFE;
  AUTH_MEMBER_INVITATION_ACCEPT_SUCC: MvnCodeFE;
  AUTH_MEMBER_INVITATION_ACCEPT_FAIL: MvnCodeFE;
  AUTH_MEMBER_INVITATION_REJECT_SUCC: MvnCodeFE;
  AUTH_MEMBER_INVITATION_REJECT_FAIL: MvnCodeFE;
  AUTH_MEMBER_INVITATION_CANCEL_SUCC: MvnCodeFE;
  AUTH_MEMBER_INVITATION_CANCEL_FAIL: MvnCodeFE;
  AUTH_MEMBER_REMOVE_INVITATION_TITLE: MvnCodeFE;
  AUTH_MEMBER_REMOVE_INVITATION_DESC: MvnCodeFE;
  AUTH_MEMBER_REMOVE_INVITATION_SUCC: MvnCodeFE;
  AUTH_MEMBER_REMOVE_INVITATION_FAIL: MvnCodeFE;
  AUTH_MEMBER_REMOVE_MEMBER_TITLE: MvnCodeFE;
  AUTH_MEMBER_REMOVE_MEMBER_DESC: MvnCodeFE;
  AUTH_MEMBER_REMOVE_MEMBER_SUCC: MvnCodeFE;
  AUTH_MEMBER_REMOVE_MEMBER_FAIL: MvnCodeFE;
  AUTH_MEMBER_INVITATION_DESC: MvnCodeFE;
} = {
  AUTH_MEMBER_INVITE_TITLE: {
    ko: "멤버 초대",
    en: "Invite Member",
  },
  AUTH_MEMBER_INVITE_HEADER: {
    ko: "Org 선택 후, 초대할 멤버의 이메일 주소를 입력하세요.",
    en: "Please enter the email address of the member to invite after selecting the Org.",
  },
  AUTH_MEMBER_INVITE_SELECT_ORG_NAME_LABEL: {
    ko: "Organization 이름",
    en: "Organization Name",
  },
  AUTH_MEMBER_INVITE_SELECT_ORG_NAME_PLACEHOLDER: {
    ko: "Organization을 선택해주세요",
    en: "Select the Organization",
  },
  AUTH_MEMBER_INVITE_EMAIL_LABEL: {
    ko: "E-mail",
    en: "E-mail",
  },
  AUTH_MEMBER_INVITE_EMAIL_PLACEHOLDER: {
    ko: "Email을 입력해주세요",
    en: "Enter Member Email",
  },
  AUTH_MEMBER_INVITE_EMPTY_ORG_NOTIFY: {
    ko: "Organization을 선택해주세요.",
    en: "Please select the Organization.",
  },
  AUTH_MEMBER_INVITE_EMPTY_EMAIL_NOTIFY: {
    ko: "Email을 입력해주세요.",
    en: "Please enter the Email.",
  },
  AUTH_MEMBER_INVITE_INVALID_EMAIL_NOTIFY: {
    ko: "이메일 형식이 올바르지 않습니다.",
    en: "The email format is incorrect.",
  },

  AUTH_MEMBER_INVITE_SUCC: {
    ko: "사용자를 초대하였습니다.",
    en: "Member has been invited successfully.",
  },
  AUTH_MEMBER_INVITE_FAIL: {
    ko: "사용자 초대에 실패하였습니다. ({message})",
    en: "The member invitation request has been failed. ({message})",
  },
  AUTH_MEMBER_INVITATION_ACCEPT_CONFIRM: {
    ko: "Member 초대를 수락하시겠습니까?",
    en: "Are you sure you want to accept the invitation to a member?",
  },
  AUTH_MEMBER_INVITATION_REJECT_CONFIRM: {
    ko: "Member 초대를 거절하시겠습니까?",
    en: "Are you sure you want to reject the invitation to a member?",
  },
  AUTH_MEMBER_INVITATION_ACCEPT_SUCC: {
    ko: "Member 초대 수락이 완료되었습니다.",
    en: "Member invitation has been accepted successfully.",
  },
  AUTH_MEMBER_INVITATION_ACCEPT_FAIL: {
    ko: "Member 초대 수락에 실패하였습니다. ({message})",
    en: "The member invite acceptance request has been failed. ({message})",
  },
  AUTH_MEMBER_INVITATION_REJECT_SUCC: {
    ko: "Member 초대 거절이 완료되었습니다.",
    en: "Member invitation has been rejected successfully.",
  },
  AUTH_MEMBER_INVITATION_REJECT_FAIL: {
    ko: "Member 초대 거절에 실패하였습니다. ({message})",
    en: "The member invite rejection request has been failed. ({message})",
  },
  AUTH_MEMBER_INVITATION_CANCEL_SUCC: {
    ko: "Member 초대 취소가 완료되었습니다.",
    en: "Member invitation has been canceled successfully.",
  },
  AUTH_MEMBER_INVITATION_CANCEL_FAIL: {
    ko: "Member 초대 취소에 실패하였습니다. ({message})",
    en: "The member invite cancelation request has been failed. ({message})",
  },
  AUTH_MEMBER_REMOVE_INVITATION_TITLE: {
    ko: "{member}에게 보낸 Org 초대를 취소하시겠습니까?",
    en: "Are you sure you want to cancel the Org invitation to {member}?",
  },
  AUTH_MEMBER_REMOVE_INVITATION_DESC: {
    ko: "{member}에게 보낸 Org 초대가 취소됩니다.",
    en: "The Org invitation to {member} will be canceled.",
  },
  AUTH_MEMBER_REMOVE_INVITATION_SUCC: {
    ko: "Member 초대를 취소하였습니다.",
    en: "Member invitation has been removed successfully.",
  },
  AUTH_MEMBER_REMOVE_INVITATION_FAIL: {
    ko: "Member 초대 취소에 실패하였습니다. ({message})",
    en: "The member invitation cancellation request has been failed. ({message})",
  },
  AUTH_MEMBER_REMOVE_MEMBER_TITLE: {
    ko: "{name}을 Org에서 제거하시겠습니까?",
    en: "Are you sure you want to remove {name} from the Org?",
  },
  AUTH_MEMBER_REMOVE_MEMBER_DESC: {
    ko: "{name}을 Org에서 제거합니다.",
    en: "{name} will be removed from the Org.",
  },
  AUTH_MEMBER_REMOVE_MEMBER_SUCC: {
    ko: "Member를 삭제하였습니다.",
    en: "Member has been removed successfully.",
  },
  AUTH_MEMBER_REMOVE_MEMBER_FAIL: {
    ko: "Member 삭제에 실패하였습니다. ({message})",
    en: "The member removal request has been failed. ({message})",
  },
  AUTH_MEMBER_INVITATION_DESC: {
    ko: " You have an invitation invited by {invitation}",
    en: " You have an invitation invited by {invitation}",
  },
};

MvnCodeInitiate(AUTH_MEMBER_LANG);

export const AUTH_ORG_MEMBER_AUDIT_TRAIL_LANG: {
  AUTH_ORG_MEMBER_AUDIT_TRAIL_CREATED: MvnCodeFE;
  AUTH_ORG_MEMBER_AUDIT_TRAIL_UPDATED_REVIEWING: MvnCodeFE;
  AUTH_ORG_MEMBER_AUDIT_TRAIL_UPDATED_ACCEPTED: MvnCodeFE;
  AUTH_ORG_MEMBER_AUDIT_TRAIL_UPDATED_REJECTED: MvnCodeFE;
  AUTH_ORG_MEMBER_AUDIT_TRAIL_UPDATED_INVITATION_CANCELED: MvnCodeFE;
  AUTH_ORG_MEMBER_AUDIT_TRAIL_DELETED: MvnCodeFE;
} = {
  AUTH_ORG_MEMBER_AUDIT_TRAIL_CREATED: {
    ko: "Invited as {role}",
    en: "Invited as {role}",
  },
  AUTH_ORG_MEMBER_AUDIT_TRAIL_UPDATED_REVIEWING: {
    ko: "Reviewing",
    en: "Reviewing",
  },
  AUTH_ORG_MEMBER_AUDIT_TRAIL_UPDATED_ACCEPTED: {
    ko: "Accepted",
    en: "Accepted",
  },
  AUTH_ORG_MEMBER_AUDIT_TRAIL_UPDATED_REJECTED: {
    ko: "Rejected",
    en: "Rejected",
  },
  AUTH_ORG_MEMBER_AUDIT_TRAIL_DELETED: {
    ko: "Deleted",
    en: "Deleted",
  },
  AUTH_ORG_MEMBER_AUDIT_TRAIL_UPDATED_INVITATION_CANCELED: {
    ko: "Invitation canceled",
    en: "Invitation canceled",
  },
};

MvnCodeInitiate(AUTH_ORG_MEMBER_AUDIT_TRAIL_LANG);
